<script setup lang="ts">
import { computed } from 'vue';
import { useUserStore } from '@/store/userStore';

const props = defineProps<{
  rolesAllowed?: number[];
}>();

const userStore = useUserStore();

const isUserAuthorized = computed(() => {
  return (props.rolesAllowed ?? []).includes(userStore.user?.role);
});
</script>

<template>
  <div v-if="isUserAuthorized">
    <slot></slot>
  </div>
</template>
